var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.286,
    height: 20,
    viewBox: "0 0 18.286 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.286,17.714H5.714V10.857h6.857v6.857H16V7.429L9.143,2.286,2.286,7.429Zm0,2.286a2.2,2.2,0,0,1-1.615-.672A2.2,2.2,0,0,1,0,17.714V7.429A2.265,2.265,0,0,1,.243,6.4a2.2,2.2,0,0,1,.671-.8L7.771.457A2.412,2.412,0,0,1,8.429.114a2.289,2.289,0,0,1,1.429,0,2.412,2.412,0,0,1,.657.343L17.371,5.6a2.2,2.2,0,0,1,.672.8,2.254,2.254,0,0,1,.242,1.029V17.714A2.292,2.292,0,0,1,16,20H10.286V13.143H8V20Z",
    transform: "translate(0)",
    fill: "#9f9f9f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.3761056060dda838496f52a22ac916d3.svg";
export { ForwardRef as ReactComponent };